import PropTypes from 'prop-types'

import invariant from 'invariant'

import Enhancer from './PermissionsEnhancer'

import { arrify } from 'Global/Helpers/arrayHelpers'
import { hasPermission } from './utils'

const Permissions = props => {
  const { ignoreAdmin, permissions = [], render, renderElse, userPermissions } = props

  const arrifiedPermissions = arrify(permissions)

  invariant(arrifiedPermissions.length > 0, '`permissions` prop not provided.')

  if (!hasPermission(arrifiedPermissions, userPermissions, ignoreAdmin)) {
    return renderElse ? renderElse() : null
  }

  return render()
}

Permissions.defaultProps = {
  ignoreAdmin: false,
  permissions: [],
  renderElse: null,
}

Permissions.propTypes = {
  ignoreAdmin: PropTypes.bool,
  permissions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  render: PropTypes.func.isRequired,
  renderElse: PropTypes.func,
  userPermissions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}

export default Enhancer(Permissions)
